// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"CarwashStatus_Wrapper__39e4-","LoaderWrapper":"CarwashStatus_LoaderWrapper__2ikp0"};